var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3724 0.627628C30.2092 1.46447 30.2092 2.82125 29.3724 3.65809L3.65809 29.3724C2.82125 30.2092 1.46447 30.2092 0.627628 29.3724C-0.209209 28.5355 -0.209209 27.1788 0.627628 26.3419L26.3419 0.627628C27.1788 -0.209209 28.5355 -0.209209 29.3724 0.627628Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.627628 0.627628C1.46447 -0.209209 2.82125 -0.209209 3.65809 0.627628L29.3724 26.3419C30.2092 27.1788 30.2092 28.5355 29.3724 29.3724C28.5355 30.2092 27.1788 30.2092 26.3419 29.3724L0.627628 3.65809C-0.209209 2.82125 -0.209209 1.46447 0.627628 0.627628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.00c9d9453a19049a80b5000ea2262b5f.svg";
export { ForwardRef as ReactComponent };